
import { capitalize } from 'lodash';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class StringHelper extends Vue {

    public capitalize(text: string): string {
        return capitalize(text);
    }
}
